/**
 * Work-profile option lists (job function / job level).
 *
 * One list per enum, shared by every surface that lets someone state how they
 * work: the setup wizard, the admin user form, and the user's own profile
 * settings. The value sets mirror `shared/schemas/enums/job_function.schema.json`
 * and `job_level.schema.json`, which the backend validates against.
 *
 * `labelKey` resolves in the `user_management` namespace.
 */

import type { JobFunction, JobLevel } from '../types';

export type JobProfileOption<T> = { value: T; labelKey: string };

export const JOB_FUNCTION_OPTIONS: JobProfileOption<JobFunction>[] = [
  { value: 'sales', labelKey: 'jobFunctions.sales' },
  { value: 'marketing', labelKey: 'jobFunctions.marketing' },
  { value: 'operations', labelKey: 'jobFunctions.operations' },
  { value: 'finance', labelKey: 'jobFunctions.finance' },
  { value: 'hr', labelKey: 'jobFunctions.hr' },
  { value: 'product', labelKey: 'jobFunctions.product' },
  { value: 'engineering', labelKey: 'jobFunctions.engineering' },
  { value: 'it', labelKey: 'jobFunctions.it' },
  { value: 'customer_success', labelKey: 'jobFunctions.customer_success' },
  { value: 'legal', labelKey: 'jobFunctions.legal' },
  { value: 'general_management', labelKey: 'jobFunctions.general_management' },
  { value: 'other', labelKey: 'jobFunctions.other' },
];

export const JOB_LEVEL_OPTIONS: JobProfileOption<JobLevel>[] = [
  { value: 'individual_contributor', labelKey: 'jobLevels.individual_contributor' },
  { value: 'team_lead', labelKey: 'jobLevels.team_lead' },
  { value: 'manager', labelKey: 'jobLevels.manager' },
  { value: 'senior_manager', labelKey: 'jobLevels.senior_manager' },
  { value: 'vp', labelKey: 'jobLevels.vp' },
  { value: 'c_level', labelKey: 'jobLevels.c_level' },
];

/** Max length of `users.job_function_custom` — mirrors the column and the API guard. */
export const JOB_FUNCTION_CUSTOM_MAX_LENGTH = 100;
